"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var tool_icons_1 = require("../tool-icons");
require("./style.css");
var utils_1 = require("../utils");
var utils_2 = require("../../utils");
var noop = function () { };
var getConfigVal = function (val) {
    var res;
    val.some(function (t) {
        if (t) {
            res = t;
            return true;
        }
        else if (t === false) {
            res = false;
            return true;
        }
        return false;
    });
    return res;
};
exports.getConfigVal = getConfigVal;
// 垂直按钮，一般是直接展示的按钮
var renderVertical = function (_a) {
    var _b;
    var name = _a.name, disable = _a.disable, active = _a.active, tooltip = _a.tooltip, handler = _a.handler, editor = _a.editor, icon = _a.icon, tipDirection = _a.tipDirection, tipDistance = _a.tipDistance, tooltipVisible = _a.tooltipVisible, _c = _a.className, className = _c === void 0 ? '' : _c, _d = _a.buttonProps, buttonProps = _d === void 0 ? {} : _d, _e = _a.tooltipProps, tooltipProps = _e === void 0 ? {} : _e, toolbarType = _a.toolbarType, getRef = _a.getRef;
    var renderContent = function () {
        var content = (react_1.default.createElement(utils_1.IconButton, __assign({ onClick: function () {
                if (disable)
                    return;
                handler(editor, name, !active);
            } }, buttonProps), icon));
        if (tooltipVisible && tooltip) {
            if (typeof tooltip === 'function') {
                var tipNode = tooltip(content);
                if (typeof tipNode === 'string' && tipNode) {
                    tooltip = tipNode;
                }
                else {
                    return tipNode;
                }
            }
            return (react_1.default.createElement(utils_1.Tooltip, __assign({ content: tooltip, direction: tipDirection, distance: tipDistance }, tooltipProps), content));
        }
        return content;
    };
    return (react_1.default.createElement("div", { className: classnames_1.default('syl-toolbar-tool', (_b = {},
            _b[name] = name,
            _b[toolbarType] = toolbarType,
            _b[className] = className,
            _b.active = active,
            _b.disable = disable,
            _b)), key: name, ref: getRef }, renderContent()));
};
// 水平的按钮，一般在下拉菜单里面
var renderHorizon = function (_a) {
    var _b;
    var name = _a.name, disable = _a.disable, active = _a.active, tooltip = _a.tooltip, handler = _a.handler, editor = _a.editor, icon = _a.icon, tipDirection = _a.tipDirection, tipDistance = _a.tipDistance, tooltipVisible = _a.tooltipVisible, showName = _a.showName, _c = _a.className, className = _c === void 0 ? '' : _c, _d = _a.toolbarType, toolbarType = _d === void 0 ? 'static' : _d, buttonProps = _a.buttonProps, getRef = _a.getRef;
    if (toolbarType === 'static' &&
        typeof tooltip !== 'function' &&
        showName === tooltip) {
        tooltip = '';
    }
    var renderContent = function () {
        var content = (react_1.default.createElement(react_1.default.Fragment, null,
            icon,
            showName !== false && (react_1.default.createElement("span", { className: "tool-name" }, showName || tooltip))));
        if (tooltipVisible && tooltip) {
            if (typeof tooltip === 'function') {
                var tipNode = tooltip(content);
                if (typeof tipNode === 'string' && tipNode) {
                    if (tipNode === showName)
                        return content;
                    tooltip = tipNode;
                }
                else {
                    return tipNode;
                }
            }
            return (react_1.default.createElement(utils_1.Tooltip, { content: tooltip, direction: tipDirection || (toolbarType === 'static' ? 'left' : 'up'), distance: tipDistance }, content));
        }
        return content;
    };
    return (react_1.default.createElement(utils_1.ListItem, __assign({ className: classnames_1.default((_b = {},
            _b[name] = name,
            _b[className] = className,
            _b.active = active,
            _b.disable = disable,
            _b[toolbarType] = toolbarType,
            _b)), 
        // @ts-ignore
        onClick: function () {
            if (disable)
                return;
            handler(editor, name, !active);
        }, key: name, listRef: getRef }, buttonProps), renderContent()));
};
var ButtonForToolbar = function (props) {
    var name = props.name, attrs = props.attrs, toolbar = props.toolbar, active = props.active, configShowName = props.showName, configTooltip = props.tooltip, editor = props.editor, display = props.display, _a = props.toolbarType, toolbarType = _a === void 0 ? 'static' : _a;
    var _b = toolbar.disable, disable = _b === void 0 ? noop : _b, _c = toolbar.active, activeHandler = _c === void 0 ? noop : _c, defaultTooltip = toolbar.tooltip, defaultShowName = toolbar.showName, _d = toolbar.buttonProps, buttonProps = _d === void 0 ? {} : _d, _e = toolbar.tooltipProps, tooltipProps = _e === void 0 ? {} : _e, _f = toolbar.getRef, getRef = _f === void 0 ? noop : _f;
    var _g = react_1.useState(true), tooltipVisible = _g[0], setTooltipVisible = _g[1];
    var locale = editor.configurator.getLocaleValue(name);
    var tooltip = getConfigVal([
        configTooltip,
        locale.tooltip,
        defaultTooltip,
        name
    ]);
    var showName = getConfigVal([
        configShowName,
        locale.showName,
        defaultShowName,
        tooltip
    ]);
    var isDisable = disable(editor);
    var isActive = activeHandler(editor) || active;
    var icon = toolbar.icon || tool_icons_1.Icons[name];
    if (typeof icon === 'function') {
        // TODO: 这种方式实现动画很困难
        icon = icon(editor, attrs, {
            setTooltipVisible: setTooltipVisible,
            display: display,
            tooltip: tooltip,
            toolbarType: toolbarType
        });
    }
    var generalProps = __assign(__assign({ buttonProps: buttonProps,
        tooltipProps: tooltipProps,
        getRef: getRef }, props), { disable: isDisable, active: isActive, tooltip: tooltip,
        icon: icon,
        showName: showName,
        toolbarType: toolbarType,
        tooltipVisible: tooltipVisible });
    return props.display === utils_2.ToolDisplay.VERTICAL
        ? renderVertical(generalProps)
        : renderHorizon(generalProps);
};
exports.ButtonForToolbar = ButtonForToolbar;
//# sourceMappingURL=index.js.map